import { Box, BoxProps, Button, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { formatDateAndTime } from 'src/shared/functions/formatDate';
import { useTranslation } from 'react-i18next';
import { EventParticipantStatusEnum } from 'src/shared/models/enums/eventParticipantStatus.enum';
import { EventParticipantsProgressBar } from './eventParticipantsProgressBar';
import { EventPlaceDatePartial } from './eventPlaceDatePartial';
import { Event } from '../models/event';

const ImgBox = Box as React.ComponentType<BoxProps<'img'>>;

type EventDetailTabInformationProps = {
  event: Event;
};

export const EventDetailTabInformation = (props: EventDetailTabInformationProps) => {
  const { event } = props;
  const { t } = useTranslation();

  const [showMore, setShowMore] = useState<boolean>(false);

  const attendingParticipantsCount = event?.participants.filter((participant) => participant.status === EventParticipantStatusEnum.Attending).length;
  return (
    <GridWrapper>
      <Grid item xs={12} lg={6}>
        {event?.images?.length > 0 && (
          <Grid item xs={12}>
            <ImgBox
              component='img'
              sx={{ height: 'auto', width: '100%', borderRadius: 1 }}
              src={`data:image/png;base64,${event?.images?.[0].base64}`}
              alt={t('event:eventImage')}
            />
          </Grid>
        )}
        <Grid container sx={{ display: 'flex', flexDirection: 'row', mb: 4, mt: 3 }}>
          <Grid item xs={12} sm={6} lg={3} px={1} py={{ xs: 1, lg: 0 }}>
            <Typography variant='body1' component='div' sx={{ fontWeight: 500 }} gutterBottom>
              {t('event:participants')}
            </Typography>
            <EventParticipantsProgressBar current={attendingParticipantsCount ?? 0} total={event.maxParticipants} />
          </Grid>
          <Grid item xs={12} sm={6} lg={2} px={1} py={{ xs: 1, lg: 0 }}>
            <Typography variant='body1' component='div' sx={{ fontWeight: 500 }}>
              {t('event:fee')}
            </Typography>
            <Typography variant='body1' component='div'>
              {event.useTickets ? t('event:tickets') : `${event.fee} kr`}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} lg={3.5} px={1} py={{ xs: 1, lg: 0 }}>
            <Typography variant='body1' component='div' sx={{ fontWeight: 500 }}>
              {t('event:dateTime')}
            </Typography>
            <Typography variant='body1' component='div'>
              {formatDateAndTime(event.date)}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} lg={3.5} px={1} py={{ xs: 1, lg: 0 }}>
            <Typography variant='body1' component='div' sx={{ fontWeight: 500 }}>
              {t('event:applicationDeadline')}
            </Typography>
            <Typography variant='body1' component='div'>
              {formatDateAndTime(event.lastDateForApplication)}
            </Typography>
          </Grid>
        </Grid>
        {/* <ContentSection header={t('event:information')}> */}
        <GridWrapper>
          <Grid item xs={12}>
            <Box flex={1} px={1}>
              <Typography
                variant='body1'
                component='div'
                sx={
                  !showMore
                    ? {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '4',
                        WebkitBoxOrient: 'vertical',
                      }
                    : undefined
                }
                dangerouslySetInnerHTML={{ __html: event.description }}
              />
              {event.description && event.description.length > 150 && (
                <Button variant='text' onClick={() => setShowMore(!showMore)}>
                  {showMore ? t('common:button.showLess') : t('common:button.showMore')}
                </Button>
              )}
            </Box>
          </Grid>
        </GridWrapper>
      </Grid>
      <Grid item xs={12} lg={6}>
        <EventPlaceDatePartial event={event} />
      </Grid>
    </GridWrapper>
  );
};
